import { Badge } from '@/components/ui/badge'
import type { TemplateStatus } from '@sdr-agend/admin-schemas'

interface Props {
  status: TemplateStatus
}

const VARIANT_BY_STATUS: Record<
  TemplateStatus,
  React.ComponentProps<typeof Badge>['variant']
> = {
  DRAFT: 'secondary',
  PENDING_META: 'warning',
  APPROVED: 'success',
  REJECTED: 'destructive',
  DISABLED: 'outline',
}

const LABEL_BY_STATUS: Record<TemplateStatus, string> = {
  DRAFT: 'Rascunho',
  PENDING_META: 'Aguardando Meta',
  APPROVED: 'Aprovado',
  REJECTED: 'Rejeitado',
  DISABLED: 'Desabilitado',
}

/**
 * Color-coded status badge used by the templates registry tables and detail page.
 *
 * The variant ↔ status mapping is intentionally distinctive:
 *   - APPROVED → success (green)
 *   - REJECTED → destructive (red)
 *   - PENDING_META → warning (amber) — visually flags Meta-side wait
 *   - DRAFT → secondary (neutral) so the user can edit freely
 *   - DISABLED → outline (greyed out)
 */
export function TemplateStatusBadge({ status }: Props): React.ReactElement {
  return <Badge variant={VARIANT_BY_STATUS[status]}>{LABEL_BY_STATUS[status]}</Badge>
}
